/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ project: NonNullable<unknown>, group: NonNullable<unknown>, error: NonNullable<unknown> }} Explorer_Info_Batch_Error_GroupInputs */

const en_explorer_info_batch_error_group = /** @type {(inputs: Explorer_Info_Batch_Error_GroupInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.project} / ${i?.group}: ${i?.error}`)
};

const fr_explorer_info_batch_error_group = /** @type {(inputs: Explorer_Info_Batch_Error_GroupInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.project} / ${i?.group}: ${i?.error}`)
};

const de_explorer_info_batch_error_group = /** @type {(inputs: Explorer_Info_Batch_Error_GroupInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.project} / ${i?.group}: ${i?.error}`)
};

const it_explorer_info_batch_error_group = /** @type {(inputs: Explorer_Info_Batch_Error_GroupInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.project} / ${i?.group}: ${i?.error}`)
};

const ru_explorer_info_batch_error_group = /** @type {(inputs: Explorer_Info_Batch_Error_GroupInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.project} / ${i?.group}: ${i?.error}`)
};

const es_explorer_info_batch_error_group = /** @type {(inputs: Explorer_Info_Batch_Error_GroupInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.project} / ${i?.group}: ${i?.error}`)
};

const zh_cn2_explorer_info_batch_error_group = /** @type {(inputs: Explorer_Info_Batch_Error_GroupInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.project} / ${i?.group}: ${i?.error}`)
};

const ja_explorer_info_batch_error_group = /** @type {(inputs: Explorer_Info_Batch_Error_GroupInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.project} / ${i?.group}: ${i?.error}`)
};

const hi_explorer_info_batch_error_group = /** @type {(inputs: Explorer_Info_Batch_Error_GroupInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.project} / ${i?.group}: ${i?.error}`)
};

const pt_pt2_explorer_info_batch_error_group = /** @type {(inputs: Explorer_Info_Batch_Error_GroupInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.project} / ${i?.group}: ${i?.error}`)
};

/**
* | output |
* | --- |
* | "{project} / {group}: {error}" |
*
* @param {Explorer_Info_Batch_Error_GroupInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_batch_error_group = /** @type {((inputs: Explorer_Info_Batch_Error_GroupInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Batch_Error_GroupInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_info_batch_error_group(inputs)
	if (locale === "de") return de_explorer_info_batch_error_group(inputs)
	if (locale === "it") return it_explorer_info_batch_error_group(inputs)
	if (locale === "ru") return ru_explorer_info_batch_error_group(inputs)
	if (locale === "es") return es_explorer_info_batch_error_group(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_info_batch_error_group(inputs)
	if (locale === "ja") return ja_explorer_info_batch_error_group(inputs)
	if (locale === "hi") return hi_explorer_info_batch_error_group(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_info_batch_error_group(inputs)
	return en_explorer_info_batch_error_group(inputs)
});